<div class="container">
  <div class="table-header">
    <mat-form-field style="padding: 5px 0" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <input matInput placeholder="" value="" />
    </mat-form-field>
    <mat-paginator
      (page)="getPaginatorData($event)"
      [length]="list().length"
      [pageSizeOptions]="[10, 50, 100]"
      aria-label="Select page">
    </mat-paginator>
  </div>
  <mat-divider style="margin: 5px 0"></mat-divider>
  <mat-action-list>
    @for (obj of list() | slice: lowValue : highValue; track obj.id) {
      <mat-list-item (click)="objectClicked(obj.id)">
        <mat-icon matListItemIcon>{{ obj.icon }}</mat-icon>
        <h3 matListItemTitle>{{ obj.title }}</h3>
        <p matListItemLine>
          {{ obj.subtitle }}
        </p>
        <p matListItemMeta>{{ obj.additional_text }}</p>
      </mat-list-item>
    }
  </mat-action-list>

  <mat-divider style="margin: 5px 0"></mat-divider>
  <div class="button-row">
    <button (click)="objectClicked(-1)" color="primary" mat-raised-button>
      Add {{ objectName() }}
    </button>
  </div>
</div>
